import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors, media } from '../../utils/styles';

export const Footer = styled.div`
  margin-top: 40px;
  ${media.phone} {
    margin-top: auto;
  }
`;

export const SubmitButton = styled.button`
  background: #000000;
  border-radius: 40px;
  color: #ffffff;
  width: 234px;
  height: 58px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 15px;
  &:hover {
    opacity: 0.7;
  }
  &:disabled {
    background: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
  }
  ${media.phone} {
    width: 100%;
  }
`;

export const Container = styled.div`
  width: 1048px;
  padding: 0 20px;
  max-width: 100%;
  margin: 0 auto;
`;

const spin = keyframes`
	0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  &::after {
    border-radius: 50%;
    width: 10em;
    height: 10em;
  }
  width: 150px;
  height: 150px;
  margin: auto;
  border-top: 8px solid rgb(221, 48, 114, 0.2);
  border-right: 8px solid rgb(221, 48, 114, 0.2);
  border-bottom: 8px solid rgb(221, 48, 114, 0.2);
  border-left: 8px solid ${colors.pink};
  transform: translateZ(0);
  animation: ${spin} 1.4s infinite linear;
  border-radius: 50%;
`;

const StyledBack = styled.button`
  margin-top: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.5);
  font-size: 15px;
  svg {
    fill: rgba(0, 0, 0, 0.5);
    margin-right: 13px;
  }
`;

export const Back = ({ onBack }) => {
  return (
    <StyledBack type="button" onClick={onBack}>
      <svg
        width="17"
        height="12"
        viewBox="0 0 17 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0.46967 5.46967C0.176777 5.76256 0.176777 6.23744 0.46967 6.53033L5.24264 11.3033C5.53553 11.5962 6.01041 11.5962 6.3033 11.3033C6.59619 11.0104 6.59619 10.5355 6.3033 10.2426L2.06066 6L6.3033 1.75736C6.59619 1.46447 6.59619 0.989593 6.3033 0.6967C6.01041 0.403806 5.53553 0.403806 5.24264 0.6967L0.46967 5.46967ZM1 6.75L17 6.75L17 5.25L1 5.25L1 6.75Z" />
      </svg>
      Go Back
    </StyledBack>
  );
};
